import { Entity } from '../entity';
import { JobTemplate } from '../job.templates/job.template';
import { PartialJobCreateRequest } from '../opportunities/opportunity.convert.request';

/** Read-only preparation for converting a saved Quote to a Job. */
export interface QuoteConvertPreflight {
    customer: 'allowed' | 'blocked' | 'notFound';
    priceBook: Entity | null;
}

export interface QuoteProConvertRequest {
    _id: string;
    convertType: QuoteConvertType;
    templateStage?: Entity;
    template?: JobTemplate;
    createRequest?: PartialJobCreateRequest;
    copyActivities: boolean;
}

export enum QuoteConvertType {
    JobTemplate = 'Job Template',
    ItemCategories = 'Item categories',
    QuoteSections = 'Quote sections',
    SingleStage = 'Single stage',
}
